import axios from "axios";
import dayjs from "dayjs";

import config from "../../../config";

const POSTREST_URL = config.POSTREST_URL;

/**
 * Normalize coordinates to GeoJSON format [lon, lat]
 * API sample looks like [lat, lon] for Greece.
 */
const normalizeLonLat = (coords) => {
  if (!Array.isArray(coords) || coords.length < 2) return coords;

  const a = Number(coords[0]);
  const b = Number(coords[1]);

  const looksLikeGreeceLatLon = a >= 33 && a <= 42 && b >= 19 && b <= 33;
  return looksLikeGreeceLatLon ? [b, a] : [a, b];
};

const buildPopupHtml = (row) => {
  return `
    <div>
      <p style="margin:0;"><strong>Κατηγορία:</strong> ${row?.category ?? "-"}</p>
      <p style="margin:0;"><strong>Υποκατηγορία:</strong> ${row?.subcategory ?? "-"}</p>
      <p style="margin:0;"><strong>Status:</strong> ${row?.status ?? "-"}</p>
      <p style="margin:0;"><strong>Schedule:</strong> ${row?.schedule ?? "-"}</p>
      <p style="margin:0;"><strong>Cluster:</strong> ${row?.cluster_id ?? "-"}</p>
    </div>
  `;
};

export async function fetchInterventionCamera() {
  try {
    const { data } = await axios.get(`${POSTREST_URL}/rpc/get_interventions`, {
      headers: {
        "Accept-Profile": "interventions",
        Accept: "application/json",
      },
    });

    const rows = Array.isArray(data) ? data : [];
    const uniqueSubcategories = [...new Set(
      rows
        .map((row) => row?.subcategory?.toString().trim())
        .filter(Boolean)
    )];

    console.log("fetchInterventionCamera unique subcategories:", uniqueSubcategories);

    const TECH_SUBCATEGORY_ICONS = {
      16: "bluetooth",
      19: "vms",
    };

    const features = rows
      .filter((row) => row?.geometry_geojson?.type === "Point")
      .map((row, index) => {
        const subcategoryIcon = TECH_SUBCATEGORY_ICONS[row?.subcategory_id];
        return {
        id: row?.id ?? index + 1,
        type: "Feature",
        properties: {
          id: row?.id ?? index + 1,
          name: row?.name_el ?? "Παρέμβαση",
          popup: buildPopupHtml(row),
          displayMessage: buildPopupHtml(row),

          category_id: row?.category_id ?? null,
          category: row?.category ?? null,
          subcategory: row?.subcategory ?? null,
          subcategory_id: row?.subcategory_id ?? null,
          status: row?.status ?? null,
          schedule: row?.schedule ?? null,
          cluster_id: row?.cluster_id ?? null,
          created_at: row?.created_at ?? null,
          updated_at: row?.updated_at ?? null,
          ...(subcategoryIcon ? { icon: subcategoryIcon } : {}),
        },
        geometry: {
          type: "Point",
          coordinates: normalizeLonLat(
            row.geometry_geojson.coordinates
          ),
        },
        };
      });

    return {
      type: "FeatureCollection",
      features,
    };
  } catch (error) {
    console.error("fetchInterventionCamera error:", error);
    throw error;
  }
}

